import React, { useState } from 'react';
import { Empty, Input, Tag } from 'antd';
import styles from './modal.module.css';

function personName(by) {
    if (!by) return 'Author not recorded';
    const text = String(by);
    const email = text.includes('@') ? text.split(' ').find(part => part.includes('@')) : '';
    const name = text.replace(email || '', '').replace(/[()-]/g, '').trim();
    return name || email || text;
}

function CommentCard({ item, kind }) {
    const text = kind === 'rawqc' ? item?.comment : item?.text;
    const by = item?.by;
    return (
        <div className={styles.comment}>
            <div className={styles.commentTop}>
                <strong>{personName(by)}</strong>
                <Tag color={kind === 'rawqc' ? 'orange' : 'green'}>{kind === 'rawqc' ? 'Raw QC' : 'Photographer'}</Tag>
            </div>
            <div className={styles.commentBody}>{text || 'No comment text recorded'}</div>
            <div className={styles.commentTime}>{item?.at ? new Date(item.at).toLocaleString() : ''}</div>
            {by ? <div className={styles.commentTime}>{by}</div> : null}
        </div>
    );
}

export default function CommentsTab({ sku }) {
    const [filter, setFilter] = useState('all');
    const [query, setQuery] = useState('');
    const raw = (sku?.rawQCFilesCommentsMerged || []).map(item => ({ ...item, kind: 'rawqc' }));
    const photo = (sku?.photoShootComments || []).map(item => ({ ...item, kind: 'photo' }));
    const q = query.trim().toLowerCase();
    const rows = [...raw, ...photo]
        .filter(item => filter === 'all' || (filter === 'rawqc' ? item.kind === 'rawqc' : item.kind === 'photo'))
        .filter(item => {
            if (!q) return true;
            const text = `${item.comment || ''} ${item.text || ''} ${item.by || ''}`.toLowerCase();
            return text.includes(q);
        })
        .sort((a, b) => new Date(b.at || 0) - new Date(a.at || 0));

    return (
        <div className={styles.grid}>
            <div>
                <div className={styles.filters}>
                    {[
                        ['all', 'All comments'],
                        ['rawqc', 'Raw QC'],
                        ['photo', 'Photographer'],
                    ].map(([key, label]) => (
                        <button
                            type="button"
                            key={key}
                            className={filter === key ? `${styles.chip} ${styles.chipActive}` : styles.chip}
                            onClick={() => setFilter(key)}
                        >
                            {label}
                        </button>
                    ))}
                    <Input allowClear placeholder="Search comments" value={query} onChange={event => setQuery(event.target.value)} style={{ maxWidth: 240 }} />
                </div>
                {rows.length ? rows.map((item, index) => <CommentCard key={`${item.kind}-${item.at}-${index}`} item={item} kind={item.kind} />) : <Empty description="No comments" />}
            </div>
            <div className={styles.card}>
                <h3 className={styles.cardTitle}>Comment categories</h3>
                <div className={styles.snapshotRow}>
                    <span>Raw QC</span>
                    <span>{raw.length}</span>
                </div>
                <div className={styles.snapshotRow}>
                    <span>Photographer</span>
                    <span>{photo.length}</span>
                </div>
            </div>
        </div>
    );
}
